module.exports = __webpack_public_path__ + "static/media/ic_reminder.5427d004.svg";